/* =====================================================================
   VuRoot — Conversion Engine
   Powers all 20 urgency elements. Pure vanilla JS, no dependencies.
   Safe to run on Shopify (uses localStorage/sessionStorage with guards)
   and as a standalone preview.
   ===================================================================== */
(function(){
  "use strict";
  var $  = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var pad = function(n){return (n<10?"0":"")+n;};
  function store(){try{return window.localStorage;}catch(e){return null;}}
  function sess(){try{return window.sessionStorage;}catch(e){return null;}}

  /* ---------- date helpers ---------- */
  function nextSunday(){ // Sunday 23:59:59 local (deal deadline)
    var d=new Date(); var day=d.getDay(); var add=(7-day)%7; // 0 if Sunday
    var t=new Date(d.getFullYear(),d.getMonth(),d.getDate()+add,23,59,59,0);
    if(t.getTime()<=Date.now()) t=new Date(t.getTime()+7*864e5);
    return t;
  }
  function todayCutoff(hour){ // ship-today cutoff at given local hour
    var d=new Date(); var t=new Date(d.getFullYear(),d.getMonth(),d.getDate(),hour,0,0,0);
    return t;
  }

  /* ---------- generic countdown renderer ---------- */
  function fmt(ms,opts){
    if(ms<0) ms=0;
    var s=Math.floor(ms/1000);
    var d=Math.floor(s/86400); s-=d*86400;
    var h=Math.floor(s/3600);  s-=h*3600;
    var m=Math.floor(s/60);    s-=m*60;
    if(opts==="dhms") return (d>0?d+"d ":"")+pad(h)+":"+pad(m)+":"+pad(s);
    if(opts==="hms")  return pad(h+d*24)+":"+pad(m)+":"+pad(s);
    if(opts==="ms")   return pad(m+h*60+d*1440)+":"+pad(s);
    return {d:d,h:h,m:m,s:s};
  }

  /* =====================================================================
     #1/#2/#3 site-wide  + product tier countdowns — deadline-based timers
     ===================================================================== */
  function tickDeadlines(){
    // simple text targets [data-cd]
    $$("[data-cd]").forEach(function(el){
      var target=el.getAttribute("data-cd");
      var style=el.getAttribute("data-cd-style")||"dhms";
      var end;
      if(target==="sunday") end=nextSunday();
      else if(target==="cutoff"){ var hr=parseInt(el.getAttribute("data-hour")||"15",10); end=todayCutoff(hr); }
      else end=new Date(target);
      var ms=end.getTime()-Date.now();
      if(target==="cutoff" && ms<0){ el.textContent="next business day"; el.classList.add("expired"); return; }
      el.textContent=fmt(ms,style);
    });
    // segmented hero blocks [data-cd-seg]
    $$("[data-cd-seg]").forEach(function(wrap){
      var end=nextSunday(); var o=fmt(end.getTime()-Date.now());
      var map={d:o.d,h:o.h,m:o.m,s:o.s};
      $$("[data-seg]",wrap).forEach(function(s){
        s.querySelector(".n").textContent=pad(map[s.getAttribute("data-seg")]);
      });
    });
  }

  /* ---------- rolling timers (#1 product tier, #3 free bottle) ----------
     Persist a deadline N minutes out; when it lapses, roll it forward so the
     scarcity always feels live without ever hitting zero permanently.       */
  function rollingEnd(key,minutes){
    var s=store(); var now=Date.now(); var span=minutes*60000;
    var saved=s&&s.getItem(key);
    var end=saved?parseInt(saved,10):0;
    if(!end || end<=now){ end=now+span; if(s) s.setItem(key,String(end)); }
    return end;
  }
  function tickRolling(){
    $$("[data-roll]").forEach(function(el){
      var key="vuroot_roll_"+el.getAttribute("data-roll");
      var mins=parseInt(el.getAttribute("data-mins")||"180",10);
      var style=el.getAttribute("data-cd-style")||"hms";
      var end=rollingEnd(key,mins);
      el.textContent=fmt(end-Date.now(),style);
    });
  }

  /* =====================================================================
     #3 site-wide — "Today only" rotating deal in the top bar
     ===================================================================== */
  function rotator(){
    var el=$("[data-rotate]"); if(!el) return;
    var msgs;
    try{ msgs=JSON.parse(el.getAttribute("data-rotate")); }catch(e){ return; }
    if(!msgs||!msgs.length) return;
    var i=0;
    el.innerHTML=msgs[0];
    setInterval(function(){
      i=(i+1)%msgs.length;
      el.style.opacity=0;
      setTimeout(function(){ el.innerHTML=msgs[i]; el.style.opacity=1; },220);
    },5200);
    el.style.transition="opacity .22s";
  }

  /* =====================================================================
     #5 site-wide — social proof count-up
     ===================================================================== */
  function countUp(){
    $$("[data-countup]").forEach(function(el){
      var goal=parseInt(el.getAttribute("data-countup"),10);
      var suffix=el.getAttribute("data-suffix")||"";
      var done=false;
      var io=new IntersectionObserver(function(en){
        en.forEach(function(e){
          if(e.isIntersecting&&!done){
            done=true; var start=Date.now(),dur=1400;
            (function step(){
              var p=Math.min(1,(Date.now()-start)/dur);
              var ease=1-Math.pow(1-p,3);
              el.textContent=Math.floor(goal*ease).toLocaleString()+suffix;
              if(p<1) requestAnimationFrame(step);
            })();
          }
        });
      },{threshold:.4});
      io.observe(el);
    });
  }

  /* =====================================================================
     #2 product — per-bundle stock counter (gentle live decrement)
     ===================================================================== */
  function stockCounters(){
    $$("[data-stock]").forEach(function(el){
      var n=parseInt(el.getAttribute("data-stock"),10);
      var floor=parseInt(el.getAttribute("data-floor")||"3",10);
      var max=parseInt(el.getAttribute("data-stock"),10);
      function render(){
        var numEl=$(".num",el); if(numEl) numEl.textContent=n;
        var bar=$(".bar i",el); if(bar) bar.style.width=Math.max(8,(n/max)*100)+"%";
      }
      render();
      setInterval(function(){
        if(n>floor && Math.random()<0.5){ n--; render(); }
      }, 38000+Math.random()*42000);
    });
  }

  /* =====================================================================
     Bundle selector — totals, per-day reframe, sticky bar sync
     ===================================================================== */
  var BUNDLES={
    "1":{name:"1 Bottle",now:31.99,was:31.99,sub:"30-day supply",per:"$31.99 per bottle",days:30},
    "2":{name:"2 Bottles · Save 10%",now:57.58,was:63.98,sub:"60-day supply",per:"$28.79 per bottle",days:60},
    "3":{name:"Buy 3, Get 1 Free",now:95.97,was:127.96,sub:"4 bottles · 120-day supply",per:"$23.99 per bottle",days:120}
  };
  function money(n){return "$"+n.toFixed(2);}
  function selectBundle(key){
    var b=BUNDLES[key]; if(!b) return;
    $$(".bundle").forEach(function(x){x.classList.toggle("sel",x.getAttribute("data-bundle")===key);});
    var tot=$("[data-total]"); if(tot) tot.textContent=money(b.now);
    var save=$("[data-save]");
    if(save){ var s=b.was-b.now; save.textContent = s>0? "You save "+money(s) : ""; }
    var pd=$("[data-perday]");
    if(pd){ pd.textContent="$"+(b.now/b.days).toFixed(2); }
    // sticky bar
    var sn=$("[data-sticky-name]"); if(sn) sn.textContent=b.name;
    var sp=$("[data-sticky-now]"); if(sp) sp.textContent=money(b.now);
    var sw=$("[data-sticky-was]"); if(sw) sw.textContent=b.was>b.now?money(b.was):"";
    // pay-in-4
    var p4=$("[data-pay4]"); if(p4) p4.textContent=money(b.now/4);
  }
  function bundleEvents(){
    $$(".bundle").forEach(function(b){
      b.addEventListener("click",function(){selectBundle(b.getAttribute("data-bundle"));});
    });
    var pre=$(".bundle.sel"); selectBundle(pre?pre.getAttribute("data-bundle"):"2");
  }

  /* =====================================================================
     #6 product — cart-reservation timer after add-to-cart
     ===================================================================== */
  function reservation(){
    var box=$("[data-reserve]"); if(!box) return;
    var cdEl=$(".cd",box);
    function start(){
      var s=sess(); var end=s&&s.getItem("vuroot_reserve");
      var t=end?parseInt(end,10):0;
      if(!t||t<=Date.now()){ t=Date.now()+10*60000; if(s) s.setItem("vuroot_reserve",String(t)); }
      box.classList.add("show");
      (function tick(){
        var ms=t-Date.now();
        if(ms<=0){ if(cdEl) cdEl.textContent="00:00"; return; }
        if(cdEl) cdEl.textContent=fmt(ms,"ms");
        setTimeout(tick,1000);
      })();
    }
    $$("[data-atc]").forEach(function(btn){
      btn.addEventListener("click",function(e){
        // demo guard: in the real theme this links to /cart/add — keep default there.
        if(btn.getAttribute("data-demo")==="1"){ e.preventDefault(); }
        start();
        var cart=$("[data-cart-count]"); if(cart){ cart.textContent="("+( (parseInt(cart.textContent.replace(/\D/g,""),10)||0)+1 )+")"; }
      });
    });
    // if a reservation is already running this session, resume it
    var s=sess(); if(s&&s.getItem("vuroot_reserve") && parseInt(s.getItem("vuroot_reserve"),10)>Date.now()) start();
  }

  /* =====================================================================
     #8 product — sticky add-to-cart bar (appears past the bundle block)
     ===================================================================== */
  function stickyBar(){
    var bar=$(".sticky-atc"); var anchor=$("[data-atc-anchor]");
    if(!bar||!anchor) return;
    var io=new IntersectionObserver(function(en){
      en.forEach(function(e){ bar.classList.toggle("show",!e.isIntersecting && e.boundingClientRect.top<0); });
    },{threshold:0});
    io.observe(anchor);
  }

  /* =====================================================================
     #6 site-wide + #9 product — live order ticker / recent-buyer toast
     Verified-style (real orders only in production; demo data here).
     ===================================================================== */
  var ORDERS=[
    {n:"Maria G.",c:"Houston, TX",i:"the 3-pack (Buy 3 Get 1 Free)"},
    {n:"James P.",c:"Tampa, FL",i:"a 2-bottle bundle"},
    {n:"Linda H.",c:"Phoenix, AZ",i:"the 3-pack"},
    {n:"Robert K.",c:"Columbus, OH",i:"a 2-bottle bundle"},
    {n:"Denise M.",c:"San Diego, CA",i:"the 4-bottle pack"},
    {n:"Walter S.",c:"Naples, FL",i:"a single bottle"},
    {n:"Patricia L.",c:"Denver, CO",i:"the 3-pack"},
    {n:"George A.",c:"Atlanta, GA",i:"a 2-bottle bundle"},
    {n:"Susan R.",c:"Seattle, WA",i:"the Buy 3 Get 1 Free"},
    {n:"Frank D.",c:"Boston, MA",i:"the 4-bottle pack"}
  ];
  function ticker(){
    var t=$(".toast"); if(!t) return;
    var nameEl=$(".tx .n",t), msgEl=$(".tx .m",t);
    var i=Math.floor(Math.random()*ORDERS.length);
    function show(){
      var o=ORDERS[i%ORDERS.length]; i++;
      var mins=Math.floor(Math.random()*14)+2;
      nameEl.textContent=o.n+" — "+o.c;
      msgEl.textContent="ordered "+o.i+" · "+mins+" min ago";
      t.classList.add("show");
      setTimeout(function(){ t.classList.remove("show"); }, 5200);
    }
    setTimeout(function(){
      show();
      setInterval(show, 13000+Math.random()*6000);
    }, 6000);
    $(".close",t).addEventListener("click",function(){ t.classList.remove("show"); t.dataset.off="1"; });
  }

  /* =====================================================================
     #8 site-wide — email/SMS popup with one-time expiring code
     ===================================================================== */
  function emailPopup(){
    var bg=$(".modal-bg"); if(!bg) return;
    var s=sess();
    if(s&&s.getItem("vuroot_popup_seen")) return;
    var expEl=$(".codebox .exp",bg);
    var shown=false, expTimer=null, expEnd=0;
    function open(){
      if(shown) return; shown=true;
      bg.classList.add("show");
      if(s) s.setItem("vuroot_popup_seen","1");
      expEnd=Date.now()+15*60000;
      (function tick(){
        if(!bg.classList.contains("show")) return;
        var ms=expEnd-Date.now();
        if(expEl) expEl.textContent="expires in "+fmt(ms<0?0:ms,"ms");
        if(ms>0) expTimer=setTimeout(tick,1000);
      })();
    }
    function close(){ bg.classList.remove("show"); if(expTimer) clearTimeout(expTimer); }
    // open after 12s OR on exit-intent
    var t=setTimeout(open,12000);
    document.addEventListener("mouseout",function(e){
      if(e.clientY<=0 && !shown){ clearTimeout(t); open(); }
    });
    bg.addEventListener("click",function(e){ if(e.target===bg) close(); });
    $$("[data-close-modal]",bg).forEach(function(b){ b.addEventListener("click",close); });
    var form=$("[data-popup-form]",bg);
    if(form) form.addEventListener("submit",function(e){
      e.preventDefault();
      var body=$(".modal .body",bg);
      body.innerHTML='<div style="text-align:center;padding:6px 0 4px"><div style="font-family:var(--serif);font-weight:800;font-size:22px;color:var(--ink)">You\u2019re in \u2705</div><p style="color:var(--slate);font-size:14px;margin:8px 0 0">Code <b style="color:var(--orange-600)">SEE10</b> is applied at checkout. Hurry \u2014 it expires in 15 minutes.</p><a href="#bundles" data-close-modal class="btn btn-primary btn-block" style="margin-top:16px">Shop now &rarr;</a></div>';
      $$("[data-close-modal]",bg).forEach(function(b){ b.addEventListener("click",close); });
    });
  }

  /* =====================================================================
     FAQ accordion
     ===================================================================== */
  function faq(){
    $$(".qa button").forEach(function(b){
      b.addEventListener("click",function(){ b.parentNode.classList.toggle("open"); });
    });
  }

  /* ---------- boot ---------- */
  function boot(){
    tickDeadlines(); tickRolling();
    setInterval(function(){ tickDeadlines(); tickRolling(); }, 1000);
    rotator(); countUp(); stockCounters(); bundleEvents();
    reservation(); stickyBar(); ticker(); emailPopup(); faq();
  }
  if(document.readyState!=="loading") boot();
  else document.addEventListener("DOMContentLoaded",boot);
})();
